var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.611 23.389A5.464 5.464 0 0 1 15 19.5c0-1.468.572-2.849 1.611-3.888A5.465 5.465 0 0 1 20.5 14c1.469 0 2.85.573 3.889 1.612A5.463 5.463 0 0 1 26 19.5c0 1.469-.572 2.85-1.611 3.889A5.464 5.464 0 0 1 20.5 25a5.464 5.464 0 0 1-3.889-1.611Zm13.392 4.907-4.57-4.571A6.446 6.446 0 0 0 27 19.5a6.453 6.453 0 0 0-1.904-4.595A6.456 6.456 0 0 0 20.5 13a6.458 6.458 0 0 0-4.596 1.905A6.453 6.453 0 0 0 14 19.5c0 1.737.676 3.368 1.904 4.596A6.457 6.457 0 0 0 20.5 26a6.446 6.446 0 0 0 4.226-1.568l4.57 4.571.707-.707Z",
    fill: "#000624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20v-1h5v1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20 4-3 3h6l-3-3ZM20 36l-3-3h6l-3 3ZM4 19l3-3v6l-3-3ZM36 19l-3-3v6l3-3Z",
    fill: "#000624"
  })));
};
export default SvgZoomOut;